import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import {
  PiBooksLight,
  PiBuildingsLight,
  PiFirstAidKitLight,
  PiTrafficConeLight,
  PiChatCircleTextLight,
  PiMapPinAreaLight,
  PiScissorsLight,
  PiScrollLight,
  PiSoccerBallLight,
} from 'react-icons/pi';
import { getSiteSettings } from '../../api/siteSettings';

function ServicesSlider() {
  const [siteSettings, setSiteSettings] = useState(null);
  const brandColor = 'rgb(8, 73, 119)';

  useEffect(() => {
    const fetchSiteSettings = async () => {
      try {
        const response = await getSiteSettings();
        if (response.isSuccess) {
          setSiteSettings(response.data);
        }
      } catch (error) {
        console.error('Error fetching site settings:', error);
      }
    };

    fetchSiteSettings();
  }, []);

  const services = [
    {
      id: 1,
      title: 'E-Imar',
      icon: PiMapPinAreaLight,
      iconColor: brandColor,
      link: 'https://keos.iskenderun.bel.tr:8787/imardurumu/index.aspx',
      isExternal: true
    },
    {
      id: 2,
      title: 'E-Belediye',
      icon: PiBuildingsLight,
      iconColor: brandColor,
      link: 'https://webportal.iskenderun.bel.tr/engine/index.php',
      isExternal: true
    },
    {
      id: 3,
      title: 'Bize Bildir',
      icon: PiChatCircleTextLight,
      iconColor: brandColor,
      link: '/bize-bildir',
      isExternal: false
    },
    {
      id: 4,
      title: 'Nöbetçi Eczaneler',
      lineBreak: true,
      icon: PiFirstAidKitLight,
      iconColor: brandColor,
      link: '/nobetci-eczaneler',
      isExternal: false
    },
    {
      id: 9,
      title: 'Kütüphane Randevu Sistemi',
      lineBreak: true,
      icon: PiBooksLight,
      iconColor: brandColor,
      link: '/hizmet-rehberi/kutuphane-randevu',
      isExternal: false
    },
    {
      id: 6,
      title: 'Kuaför Randevu Sistemi',
      lineBreak: true,
      icon: PiScissorsLight,
      iconColor: brandColor,
      link: siteSettings?.barberUrl || 'https://ebelediye.iskenderun.bel.tr/webportal/index.php?wwsayfa=8100',
      isExternal: true
    },
    {
      id: 5,
      title: 'İhaleler',
      icon: PiScrollLight,
      iconColor: brandColor,
      link: '/ihaleler',
      isExternal: false
    },
    {
      id: 7,
      title: 'Spor Randevu Sistemi',
      lineBreak: true,
      icon: PiSoccerBallLight,
      iconColor: brandColor,
      link: '/hizmet-rehberi/spor-randevu',
      isExternal: false
    },
    {
      id: 8,
      title: 'Mahallem Gelişiyor',
      icon: PiTrafficConeLight,
      iconColor: brandColor,
      link: '/mahalleler',
      isExternal: false
    }
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 4000,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  };

  const renderTitle = (service) => {
    if (!service.lineBreak) {
      return service.title;
    }

    const words = service.title.split(' ');
    const midpoint = Math.ceil(words.length / 2);

    return (
      <>
        {words.slice(0, midpoint).join(' ')}
        <br />
        {words.slice(midpoint).join(' ')}
      </>
    );
  };

  const renderCard = (service) => {
    const ServiceIcon = service.icon;

    return (
      <div className="service-card">
        <div className="service-icon">
          <div className="service-icon-frame">
            <ServiceIcon size={44} color={service.iconColor} />
          </div>
        </div>
        <h3 className="service-title" style={{ background: service.iconColor }}>
          {renderTitle(service)}
        </h3>
      </div>
    );
  };

  const renderLink = (service) => {
    if (service.isExternal) {
      return (
        <a
          key={service.id}
          href={service.link}
          target="_blank"
          rel="noopener noreferrer"
          className="service-link"
        >
          {renderCard(service)}
        </a>
      );
    }

    return (
      <Link key={service.id} to={service.link} className="service-link">
        {renderCard(service)}
      </Link>
    );
  };

  return (
    <div className="services-slider-section">
      <div className="services-grid-desktop">
        {services.map((service) => renderLink(service))}
      </div>

      <div className="services-slider-mobile">
        <Slider {...settings} className="services-slider">
          {services.map((service) => (
            <div key={service.id} className="service-slide">
              {renderLink(service)}
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default ServicesSlider;
